import React, { useContext } from "react";

// Components

import AppPage from "@/ui/AppPage/AppPage";
import MainMap from "@/views/GIS/MapPage/MainMap";

import { Permissions } from "@/lib/permissions";

import MapRoutingProvider from "@/components/MapRoutingContext/MapRoutingProvider";
import UserContext from "@/components/UserContext/UserContext";

// Types
import { UserContextType } from "@/@types/context/UserContext";

function HPSMapPage() {

  const userContext = useContext(UserContext) as UserContextType

  const mapId = userContext.hasAnyPermission([Permissions.HPSKomisijaView]) ? 336 : 300;

  return (
    <AppPage needPermission={[Permissions.HPSRead, Permissions.HPSSharedView]}>
      <MapRoutingProvider>
        <MainMap mapId={mapId} />
      </MapRoutingProvider>
    </AppPage>
  );
}

export default HPSMapPage;
